"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }













var _peers = require('shared/selectors/peers');
var _relations = require('shared/selectors/user/relations');
var _translationLanguages = require('shared/constants/translationLanguages');


/* Lane E translation and spam labels: the rules every client follows to
 * decide what a staff member sees. The server owns the decisions (whether
 * the pill shows, which messages are translated); these only gate them on
 * the server and org settings. */




const LANGUAGES_BY_CODE = new Map(
  _translationLanguages.TRANSLATION_LANGUAGES.map(language => [language.code.toLowerCase(), language]),
)

const findLanguage = (code) => {
  const lower = code.toLowerCase()
  const alias = _translationLanguages.TRANSLATION_LANGUAGE_ALIASES[lower]
  return _nullishCoalesce(LANGUAGES_BY_CODE.get(lower), () => ( (alias ? LANGUAGES_BY_CODE.get(alias.toLowerCase()) : undefined)))
}

/* The listed code for code, ignoring case and following Google's aliases
 * ('iw' is 'he'), or undefined when it isn't offered. */
 const canonicalLanguage = (code) =>
  code ? _optionalChain([findLanguage, 'call', _ => _(code), 'optionalAccess', _2 => _2.code]) : undefined; exports.canonicalLanguage = canonicalLanguage

/* "Vietnamese" for 'vi', "Chinese (Simplified)" for 'zh-CN'. An unlisted
 * code falls back to its base language's name ('es-MX' is "Spanish"), then
 * to the code as written. */
 const languageName = (code) => {
  if (!code) return ''
  return _nullishCoalesce(_optionalChain([(_nullishCoalesce(findLanguage(code), () => ( findLanguage(_nullishCoalesce(code.split('-')[0], () => ( '')))))), 'optionalAccess', _3 => _3.name]), () => ( code))
}; exports.languageName = languageName

/* Picking any language but English means "always translate". */
 const alwaysTranslates = (language) => language !== 'en'; exports.alwaysTranslates = alwaysTranslates

/* The languages whose English name or code matches what staff typed
 * ("viet", "vi"), in name order. An empty query matches every language. */
 const searchTranslationLanguages = (query) => {
  const q = query.trim().toLowerCase()
  if (!q) return _translationLanguages.TRANSLATION_LANGUAGES
  return _translationLanguages.TRANSLATION_LANGUAGES.filter(({ code, name }) =>
    name.toLowerCase().includes(q) || code.toLowerCase() === q || code.toLowerCase().startsWith(`${q}-`))
}; exports.searchTranslationLanguages = searchTranslationLanguages

 const selectConversationTranslation = (
  state,
  conversationKey,
) =>
  _optionalChain([state, 'access', _4 => _4.conversationTranslations, 'optionalAccess', _5 => _5[conversationKey]]); exports.selectConversationTranslation = selectConversationTranslation

 const selectOrgTranslationSettings = (
  state,
  orgKey,
) =>
  _optionalChain([state, 'access', _6 => _6.orgTranslationSettings, 'optionalAccess', _7 => _7[orgKey]]); exports.selectOrgTranslationSettings = selectOrgTranslationSettings

/* The chats some mounted chat view shows (useConversationTranslationSync). */
 const selectIsTranslationConversationActive = (
  state,
  conversationKey,
) => (_nullishCoalesce(_optionalChain([state, 'access', _8 => _8.translationSync, 'optionalAccess', _9 => _9.active, 'access', _10 => _10[conversationKey]]), () => ( 0))) > 0; exports.selectIsTranslationConversationActive = selectIsTranslationConversationActive

/* A Translate in this chat is waiting for the server (translateFromMessage). */
 const selectIsTranslatingFromMessage = (
  state,
  conversationKey,
) => !!_optionalChain([state, 'access', _11 => _11.translationSync, 'optionalAccess', _12 => _12.translating, 'optionalAccess', _13 => _13[conversationKey]]); exports.selectIsTranslatingFromMessage = selectIsTranslatingFromMessage

 const selectActiveTranslationConversationKeys = (state) =>
  // SAFETY: `active` is keyed by ConversationKey; Object.keys drops the brand.
  Object.keys(_nullishCoalesce(_optionalChain([state, 'access', _14 => _14.translationSync, 'optionalAccess', _15 => _15.active]), () => ( {}))) ; exports.selectActiveTranslationConversationKeys = selectActiveTranslationConversationKeys

/* Translation is available on this server (TRANSLATE_ENABLED). Without it
 * every control hides: nothing could be translated. */
 const isTranslationServerEnabled = (state) =>
  _optionalChain([state, 'optionalAccess', _16 => _16.ServerEnabled]) !== false; exports.isTranslationServerEnabled = isTranslationServerEnabled

/* The chat's translation controls (its Language item, Translate in a
 * message's menu) show in a patient chat while the server translates. They
 * stay visible when the org has translation off: using one then explains
 * that (isTranslationOffForOrg). */
 const shouldShowTranslationControls = (state) =>
  !!state && state.Available && exports.isTranslationServerEnabled.call(void 0, state); exports.shouldShowTranslationControls = shouldShowTranslationControls

/* The org has turned translation off (or turned off translating patient
 * messages): the controls open "Translation is turned off for <org>"
 * instead of acting. */
 const isTranslationOffForOrg = (state) =>
  !!state && (!state.OrgEnabled || !state.TranslateInbound); exports.isTranslationOffForOrg = isTranslationOffForOrg

/* The org translates neither way (or has translation off), so a patient's
 * language does nothing: the Language item and its Stop explain that
 * instead of acting. With only replies translated the language is still
 * set and stopped from there. */
 const isLanguageOffForOrg = (state) =>
  !!state && (!state.OrgEnabled || (!state.TranslateInbound && !state.TranslateOutbound)); exports.isLanguageOffForOrg = isLanguageOffForOrg

/* "Translation is turned off for Sunny Clinic. Ask an admin to turn it on." */
 const translationOffForOrgMessage = (orgName) =>
  `Translation is turned off for ${orgName || 'your organization'}. Ask an admin to turn it on.`; exports.translationOffForOrgMessage = translationOffForOrgMessage

/* Translated text, the labels under bubbles and the pill show only while
 * the org has translation on. */
 const shouldShowTranslations = (state) =>
  exports.shouldShowTranslationControls.call(void 0, state) && state.OrgEnabled; exports.shouldShowTranslations = shouldShowTranslations

/* The message the "Not English · Translate?" pill sits under, or
 * undefined. */
 const getVisiblePillMessageKey = (state) =>
  exports.shouldShowTranslations.call(void 0, state) && !state.Language && state.PillMessageKey
    ? state.PillMessageKey
    : undefined; exports.getVisiblePillMessageKey = getVisiblePillMessageKey

/* The server picks the pill from labels written just after a patient
 * message is saved, so an answer fetched for a new message can come back
 * without a pill only because the label isn't there yet: worth asking
 * again while a pill could still show. */
 const couldPillStillAppear = (state) =>
  exports.shouldShowTranslations.call(void 0, state) && !state.Language && !state.PillMessageKey; exports.couldPillStillAppear = couldPillStillAppear

/* Primitive selectors, so a row subscribing to them re-renders only when the
 * answer changes. */
 const selectShowTranslations = (state, conversationKey) =>
  exports.shouldShowTranslations.call(void 0, exports.selectConversationTranslation.call(void 0, state, conversationKey)); exports.selectShowTranslations = selectShowTranslations

/* Staff dismissed this chat's pill during this app session
 * (actions.dismissTranslationPill). */
 const selectIsTranslationPillDismissed = (state, conversationKey) =>
  !!_optionalChain([state, 'access', _17 => _17.translationSync, 'optionalAccess', _18 => _18.pillDismissed, 'optionalAccess', _19 => _19[conversationKey]]); exports.selectIsTranslationPillDismissed = selectIsTranslationPillDismissed

 const selectVisiblePillMessageKey = (state, conversationKey) =>
  exports.selectIsTranslationPillDismissed.call(void 0, state, conversationKey)
    ? undefined
    : exports.getVisiblePillMessageKey.call(void 0, exports.selectConversationTranslation.call(void 0, state, conversationKey)); exports.selectVisiblePillMessageKey = selectVisiblePillMessageKey

/* The pill's wording: "Spanish? Translate" when the server names the
 * message's language, otherwise "Not English · Translate?". The accessible
 * name says the same as a sentence. */






 const getPillCopy = (pillLanguage) => pillLanguage
  ? {
      lead: `${exports.languageName.call(void 0, pillLanguage)}?`,
      action: 'Translate',
      accessibilityLabel: `Message looks like ${exports.languageName.call(void 0, pillLanguage)}. Translate this message.`,
    }
  : { lead: 'Not English ·', action: 'Translate?', accessibilityLabel: 'Message is not in English. Translate this message.' }; exports.getPillCopy = getPillCopy

 const selectPillCopy = (state, conversationKey) =>
  exports.getPillCopy.call(void 0, _optionalChain([exports.selectConversationTranslation.call(void 0, state, conversationKey), 'optionalAccess', _20 => _20.PillLanguage])); exports.selectPillCopy = selectPillCopy

/* A patient message's translation as it should render:
 * - 'translated': show the English, with "Translated from Vietnamese";
 * - 'saved': translation is off (for the org or this patient), but the
 *   message was translated before: show the original, with "Show
 *   translation" revealing the saved English (no new call);
 * - 'failed': show the original, with "Translation unavailable";
 * - null: show the original, with no label. */






const hasText = (t) =>
  !!_optionalChain([t, 'optionalAccess', _21 => _21.Text]) && t.Text.trim() !== ''

 const shouldShowTranslated = (message, state) =>
  exports.shouldShowTranslations.call(void 0, state) && _optionalChain([message, 'access', _22 => _22.Translation, 'optionalAccess', _23 => _23.Status]) === 'ok' && hasText(message.Translation); exports.shouldShowTranslated = shouldShowTranslated

 const getInboundTranslationDisplay = (
  message,
  showTranslations,
) => {
  const translation = message.Translation
  if (!translation) return null
  if (!showTranslations) {
    return translation.Status === 'ok' && hasText(translation)
      ? { kind: 'saved', text: translation.Text, sourceLanguage: translation.SourceLanguage }
      : null
  }
  if (translation.Status === 'ok' && hasText(translation)) {
    return { kind: 'translated', text: translation.Text, sourceLanguage: translation.SourceLanguage }
  }
  if (translation.Status === 'failed') return { kind: 'failed' }
  return null
}; exports.getInboundTranslationDisplay = getInboundTranslationDisplay

/* What a staff message's patient got:
 * - 'translated': "Sent in Spanish", with the delivered text one click away;
 * - 'as-written': "Sent as written (already Vietnamese)", when it was
 *   already in the patient's language;
 * - null: no label. */


















const joinNames = (names) =>
  names.length <= 1 ? (_nullishCoalesce(names[0], () => ( ''))) : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`

 const getHouseholdDeliveredDisplay = (
  deliveries,
  patients = [],
) => {
  if (deliveries.length === 0) return null
  const sorted = [...deliveries].sort((a, b) => a.PatientName.localeCompare(b.PatientName))
  const byLanguage = new Map()
  const asWritten = []
  const copies = []
  for (const delivery of sorted) {
    if (delivery.Status === 'ok' && delivery.TargetLanguage && delivery.Text) {
      byLanguage.set(delivery.TargetLanguage, [...(_nullishCoalesce(byLanguage.get(delivery.TargetLanguage), () => ( []))), delivery.PatientName])
      copies.push({ patientName: delivery.PatientName, language: delivery.TargetLanguage, text: delivery.Text })
    } else {
      asWritten.push(delivery.PatientName)
    }
  }
  const parts = [...byLanguage.entries()].map(([language, names]) => `Sent in ${exports.languageName.call(void 0, language)} to ${joinNames(names)}`)
  if (asWritten.length > 0) parts.push(`${parts.length > 0 ? 'as written' : 'Sent as written'} to ${joinNames(asWritten)}`)
  const mixed = sorted.filter(delivery => delivery.Reason === 'shared_phone_mixed')
  const hint = mixed.length > 0
    ? `${joinNames(mixed.map((delivery) => {
        const language = _optionalChain([patients, 'access', _24 => _24.find, 'call', _25 => _25(p => p.PatientKey === delivery.PatientKey), 'optionalAccess', _26 => _26.Language])
        return language ? `${delivery.PatientName} reads ${exports.languageName.call(void 0, language)}` : delivery.PatientName
      }))} on the same phone. Sent as typed.`
    : undefined
  if (byLanguage.size === 0 && !hint) return null
  return { kind: 'household', label: parts.join(' · '), copies, hint }
}; exports.getHouseholdDeliveredDisplay = getHouseholdDeliveredDisplay

 const getDeliveredDisplay = (
  message,
  showTranslations,
  patients,
) => {
  if (showTranslations && message.Deliveries && message.Deliveries.length > 0) {
    return exports.getHouseholdDeliveredDisplay.call(void 0, message.Deliveries, patients)
  }
  const delivered = message.Delivered
  if (!showTranslations || !delivered) return null
  if (delivered.Status === 'unchanged') {
    return { kind: 'as-written', language: delivered.SourceLanguage || delivered.TargetLanguage }
  }
  if (delivered.Status !== 'ok' || !hasText(delivered)) return null
  return { kind: 'translated', text: delivered.Text, targetLanguage: delivered.TargetLanguage }
}; exports.getDeliveredDisplay = getDeliveredDisplay



/* Whether a message's options menu offers Translate: on a patient's own
 * undeleted text message, in a chat whose translation controls show (with
 * the org's translation off it stays, and explains that when used), unless
 * the message already shows a translation. Translate translates only that
 * message; a patient's language is set from the Language menu, or from the
 * question Translate asks when the patient has none (selectLanguageOffer).
 * Web and mobile both use this. */
 const canTranslateFromMessage = (message, state) =>
  exports.shouldShowTranslationControls.call(void 0, state) &&
  !(_optionalChain([message, 'access', _27 => _27.Translation, 'optionalAccess', _28 => _28.Status]) === 'ok' && hasText(message.Translation)) &&
  message.SenderType === 'patient' &&
  message.MessageType === 'text' &&
  !message.Deleted &&
  !!_optionalChain([message, 'access', _29 => _29.MessageText, 'optionalAccess', _30 => _30.trim, 'call', _31 => _31()]); exports.canTranslateFromMessage = canTranslateFromMessage

/* The language offer waiting in this chat, after Translate on a message from
 * a patient with no language saved; undefined when there is none. */
 const selectLanguageOffer = (state, conversationKey) => {
  const offer = _optionalChain([state, 'access', _32 => _32.translationSync, 'optionalAccess', _33 => _33.languageOffer])
  return _optionalChain([offer, 'optionalAccess', _34 => _34.ConversationKey]) === conversationKey ? offer : undefined
}; exports.selectLanguageOffer = selectLanguageOffer

/* The offer's question, with the patient's first name, never a pronoun
 * for them: "Set Rosa's language to French?" */
 const getLanguageOfferCopy = (offer) => {
  const name = offer.FirstName.trim() || 'the patient'
  const language = exports.languageName.call(void 0, offer.Language)
  const possessive = offer.FirstName.trim() ? `${name}'s` : "the patient's"
  return {
    title: `Set ${possessive} language to ${language}?`,
    body: `Their messages will be translated for you automatically, and your replies will be sent to them in ${language}. This applies to every chat with ${name}.`,
  }
}; exports.getLanguageOfferCopy = getLanguageOfferCopy

/* "Possible spam": only a patient's message the classifier marked suspect.
 * Shown whatever the translation settings are. */
 const isSuspectedSpam = (message) =>
  message.SenderType === 'patient' && message.SpamBand === 'suspect'; exports.isSuspectedSpam = isSuspectedSpam

/* "Rosa M.", as the server's Robot lines name a patient. */
 const patientShortName = (
  patient,
) => {
  const first = _optionalChain([patient, 'optionalAccess', _35 => _35.FirstName, 'optionalAccess', _36 => _36.trim, 'call', _37 => _37()]) || ''
  const last = _optionalChain([patient, 'optionalAccess', _38 => _38.LastName, 'optionalAccess', _39 => _39.trim, 'call', _40 => _40()]) || ''
  if (first && last) return `${first} ${Array.from(last)[0]}.`
  if (first) return first
  return _optionalChain([patient, 'optionalAccess', _41 => _41.Name, 'optionalAccess', _42 => _42.trim, 'call', _43 => _43()]) || 'the patient'
}; exports.patientShortName = patientShortName

/* Org settings: the nested toggles only apply while translation is on. */
 const areNestedTranslationTogglesEnabled = (settings) =>
  !!_optionalChain([settings, 'optionalAccess', _44 => _44.Enabled]); exports.areNestedTranslationTogglesEnabled = areNestedTranslationTogglesEnabled

/* The newest patient message loaded for this chat. A new one can change the
 * pill (the server decides), so the open chat refetches its state. */
 const selectLatestPatientMessageKey = (
  state,
  conversationKey,
) => {
  const messages = _optionalChain([state, 'access', _45 => _45.dataV2, 'optionalAccess', _46 => _46.messages, 'optionalAccess', _47 => _47[conversationKey]])
  if (!messages) return undefined
  let latest
  for (const message of messages) {
    if (message.SenderType !== 'patient') continue
    if (!latest || message.Sequence > latest.Sequence) latest = message
  }
  return _optionalChain([latest, 'optionalAccess', _48 => _48.MessageKey])
}; exports.selectLatestPatientMessageKey = selectLatestPatientMessageKey

/* Where "Block number" on a "Possible spam" badge writes: the patient's
 * phone, on the patient's org's block list, through the patient-scoped
 * BlockPatientSMS (as on the patient page). That needs no line, so it works
 * in a secure chat on a team without one, where AddPhoneNumberBlock's
 * TeamKey check would fail.
 * Null when the patient has no phone, or when the current user isn't an
 * admin of the patient's org (the block list is admin-only). */






 const selectSpamBlockTarget = (
  state,
  patientKey,
) => {
  if (!patientKey) return null
  const patient = _peers.selectPatientByKey.call(void 0, state, patientKey)
  if (!_optionalChain([patient, 'optionalAccess', _49 => _49.Phone]) || !patient.OrgKey) return null
  if (!_relations.selectAmIAdminInOrg.call(void 0, state, patient.OrgKey)) return null
  return { OrgKey: patient.OrgKey, PatientKey: patientKey, PhoneNumber: patient.Phone }
}; exports.selectSpamBlockTarget = selectSpamBlockTarget

/* A patient's language wherever it shows in a chat (the chip, the picker,
 * the settings row): "Vietnamese" while translating, "Vietnamese · translation
 * off" when the language is saved but automatic translation was stopped,
 * "English", or "No language set". */
 const patientLanguageLabel = (patient) => {
  if (!patient.Language) return 'No language set'
  const name = exports.languageName.call(void 0, patient.Language)
  if (patient.Language === 'en' || patient.Translating) return name
  return `${name} · translation off`
}; exports.patientLanguageLabel = patientLanguageLabel

/* The chat's patients' translation states; a one-patient chat from an older
 * server is described by its single-patient fields. */
 const getChatPatients = (state) => {
  if (!state) return []
  if (state.Patients && state.Patients.length > 0) return state.Patients
  if (!state.PatientKey) return []
  return [{
    PatientKey: state.PatientKey,
    Name: '',
    Language: state.Language,
    AlwaysTranslate: state.AlwaysTranslate,
    Translating: !!state.Language && state.Language !== 'en' && state.AlwaysTranslate,
  }]
}; exports.getChatPatients = getChatPatients

/* Whether patientKey is in the chat: its only patient (the single-patient
 * fields) or one of a household's. A patient's language change refreshes
 * every chat they're in. */
 const hasChatPatient = (state, patientKey) =>
  !!state && (state.PatientKey === patientKey || !!_optionalChain([state, 'access', _50 => _50.Patients, 'optionalAccess', _51 => _51.some, 'call', _52 => _52(p => p.PatientKey === patientKey)])); exports.hasChatPatient = hasChatPatient

/* The composer's hint, with names, never pronouns: "Replies to Minh Tran
 * are sent in Vietnamese", or for a household "Replies are sent in Spanish
 * to Maria Lopez · as written to Leo Lopez". null when nothing would be
 * translated, or translation is off (server or org). */
 const getComposerHint = (state) => {
  if (!exports.shouldShowTranslations.call(void 0, state) || !state.TranslateOutbound) return null
  const replies = _nullishCoalesce(state.Replies, () => ( []))
  if (!replies.some(reply => reply.Language)) return null
  if (replies.length === 1) {
    return `Replies to ${replies[0].Name} are sent in ${exports.languageName.call(void 0, replies[0].Language)}`
  }
  const byLanguage = new Map()
  const asWritten = []
  for (const reply of [...replies].sort((a, b) => a.Name.localeCompare(b.Name))) {
    if (reply.Language) byLanguage.set(reply.Language, [...(_nullishCoalesce(byLanguage.get(reply.Language), () => ( []))), reply.Name])
    else asWritten.push(reply.Name)
  }
  const parts = [...byLanguage.entries()].map(([language, names]) => `in ${exports.languageName.call(void 0, language)} to ${joinNames(names)}`)
  if (asWritten.length > 0) parts.push(`as written to ${joinNames(asWritten)}`)
  return `Replies are sent ${parts.join(' · ')}`
}; exports.getComposerHint = getComposerHint

 const selectComposerHint = (state, conversationKey) =>
  exports.getComposerHint.call(void 0, exports.selectConversationTranslation.call(void 0, state, conversationKey)); exports.selectComposerHint = selectComposerHint

/* "Preview unavailable. The reply will still be translated when sent." */
 const PREVIEW_UNAVAILABLE = 'Preview unavailable. The reply will still be translated when sent.'; exports.PREVIEW_UNAVAILABLE = PREVIEW_UNAVAILABLE

/* The Language picker's Suggested entries, in order: the detected language
 * ("Vietnamese (detected)"), then the org's most-used ones, each once. */
 const getSuggestedLanguages = (
  suggestions,
) => {
  if (!suggestions) return []
  const out = []
  const seen = new Set()
  const add = (code, label) => {
    const canonical = exports.canonicalLanguage.call(void 0, code)
    if (!canonical || seen.has(canonical)) return
    seen.add(canonical)
    out.push({ code: canonical, label })
  }
  if (suggestions.Detected) add(suggestions.Detected.Language, `${exports.languageName.call(void 0, suggestions.Detected.Language)} (detected)`)
  for (const code of suggestions.OrgTop) add(code, exports.languageName.call(void 0, code))
  return out
}; exports.getSuggestedLanguages = getSuggestedLanguages
